import React from 'react'

import DataGrid from '../UI/DataGrid'
import DirectorCard from './DirectorCard'

const ListDirectors = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'fullName', title: 'Name' },
    { name: 'title', title: 'Title' },
    { name: 'email', title: 'E-mail' },
    { name: 'formattedPhones', title: 'Phones' }
  ]

  const gridRowMappingFn = director => {
    const id = director.id
    const {
      fullName,
      title,
      email,
      formattedPhones
    } = director.attributes

    return {
      id: id,
      fullName: fullName,
      title: title,
      email: email,
      formattedPhones: formattedPhones
    }
  }

  const gridSorting = [{ columnName: 'fullName', direction: 'asc' }]
  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'fullName', togglingEnabled: false }
  ]

  return (
    <DataGrid
      resourceAPIEndpoint="directors"
      resourceSingularName="Director"
      resourcePluralName="Directors"
      nameAttribute="fullName"
      clientRootPath="/directors"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      cannotDelete
      detailsCard={DirectorCard}
    />
  )
}

export default ListDirectors



// WEBPACK FOOTER //
// ./src/components/Directors/ListDirectors.jsx